import React from "react";
import {Product} from "depoto-core";
import {TagLabel} from "./TagLabel.tsx";
import './ProductDescriptionColumn.css'
import {ImagePreview} from "./ImagePreview.tsx";

type Props = {
  product: Product
  areTagsShown?: boolean
}
export const ProductDescriptionColumn: React.FC<Props> = ({ product, areTagsShown }) => (
  <div className="w-full flex flex-row justify-start">
    <div className="items-center flex">
      <ImagePreview image={product.mainImage} />
    </div>
    <div className="pl-2">
      <div className="product-name-row font-semibold">{product.fullName}</div>
      <div className="product-info-row text-base-400">
        {product.ean?.length > 0 ? (
          <div className="mr-2 whitespace-nowrap">EAN: {product.ean}</div>
        ) : null}
        {product.code?.length > 0 ? (
          <div className="mr-2 whitespace-nowrap">CODE: {product.code}</div>
        ) : null}
        {areTagsShown && product.tags?.length > 0 ? (
          product.tags.map((tag, i) => <TagLabel className="mr-1 mb-1" tag={tag} key={`tag-${tag.id}-${i}`} />)
        ) : null}
      </div>
    </div>
  </div>
)
